import React from 'react';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH6 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH3', value });
  return (
    <h6 className={className} style={style}>
      {children}
    </h6>
  );
};

RichTextH6.dispayName = 'RichTextH6';

export default RichTextH6;
